export interface PriceBand {
  low?: number | null;
  high?: number | null;
  label?: string;
}

const usable = (v: number | null | undefined): v is number =>
  typeof v === 'number' && Number.isFinite(v) && v > 0;

/** Parses the `below-above` range strings VIN_DETAILS builds with CONCAT. */
export function parsePriceRange(raw?: string | null): PriceBand | null {
  if (!raw) return null;
  const parts = raw.split('-').map((p) => Number(p.replace(/[^0-9.]/g, '')));
  if (parts.length !== 2) return null;
  const [low, high] = parts;
  if (!usable(low) || !usable(high) || high < low) return null;
  return { low, high };
}
